import * as BaseApi from "api/Base.api";

export interface IGrowthSummary {
    totalDiaryCount: number;
    totalLikeCount: number;
    totalCommentCount: number;
    totalBookmarkCount: number; // 총 북마크 카운트
    totalCastingManagerViewCount: number; // 총 뷰 카운트
    recentDiaryCount: number;
    weeklyDiaryCount: number;
    thisWeekDiaryCount: number;
    thisMonthDiaryCount: number;
    weeklyLikeCount: number;
    weeklyCommentCount: number;
    weeklyWritingFrequency: number;
    weeklyCastingManagerViewCount: number, // 지난 1주일간 캐스팅 매니저가 본 뷰 수
    monthlyCastingManagerViewCount: number, // 이번달 캐스팅 매니저가 본 뷰 수        
    lastDiaryCreatedAt: string;
    mostLikedDiary: {
        id: number;
        title: string;
        likeCount: number;
        viewCount: number;
        commentCount: number;
        bookmarkCount: number;
        createdAt: string;
    },
    mostCommentedDiary: {
        id: number;
        title: string;
        likeCount: number;
        viewCount: number;
        commentCount: number;
        bookmarkCount: number;
        createdAt: string;
    },
    mostViewedDiary: {
        id: number;
        title: string;
        likeCount: number;
        commentCount: number;
        viewCount: number;
        bookmarkCount: number;
        createdAt: string;
    },
    mostBookmarkedDiary: {
        id: number;
        title: string;
        likeCount: number;
        viewCount: number;
        commentCount: number;
        bookmarkCount: number;
        createdAt: string;
    }
}

export interface ISummaryResult {
    summary: IGrowthSummary;
}

export const getSummary = async (): Promise<ISummaryResult> => {
    const data = await BaseApi.get("/student/v2/growth/summary");
    return data as ISummaryResult;
};